import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { singleSubscription } from "../../restApi/api";
import { decrypt } from "../../utils/crypto";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "../common/Loader/Loader";
import NoDataFound from "../common/NoDataFound/NoDataFound";
import { useQuery } from "@apollo/client";
import { Package_detail_Api } from "../../gql/queries";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { authorizationCheck } from "../../utils/logout";
import ConnectionError from "../common/NoDataFound/ConnectionError";
export default function SingleSubscription() {
    let navigate = useNavigate();
    const payload = {}
    const [loader,setloader] =useState(true)
    const location = useLocation()
    if (location.state.hasOwnProperty('qb')) {
        payload.bankId = location.state.qb.subject
    }
    if (location.state.hasOwnProperty('test')) {
        payload.testId = location.state.test._id   
    }
    const [subscription,setSubscription] = useState()
    // const getSingleSubscription = async() => {
    //         try {
    //             setloader(true)
    //             const subscriptionData = await singleSubscription(payload)
    //             const resolveResponse = await subscriptionData.json()
    //             const getSingleSubscription = JSON.parse(decrypt(resolveResponse))
    //             if (getSingleSubscription.data.code === 1) {
    //                 setloader(false)
    //                 setSubscription(getSingleSubscription.data.result)
    //             }                 
    //         } catch (error) {
    //             setloader(false)
    //         }
    // }

    const query1 = useQuery(Package_detail_Api, {
        variables: {
            qbSubjectId: payload.bankId,
            testId: payload.testId,
            packageType: "SUBSCRIPTION"
        },
    });

    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
         else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname}/>
                    </div>
                    </div>
            </>)
        }
        console.log(query1.error)
    }

    return(
        <div className="main_wrapper">
                    <div className="breadcrumbs">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><a >Home</a></li>
                            <li className="breadcrumb-item active"><a >Subscription</a></li>
                        </ul>
                    </div>
                    <section className="videoLayer_wrapper subscriptions_wrapper singleSubscription_wrapper section_side_padding">
                        <div className='row'>
                            <div className="col-lg-8 col-md-7 col-sm-12">
                                <div className="recommended_video_wrapper">
                                    <div className="subscription_ttl">
                                        <h5>Subscriptions</h5>
                                    </div>
                                </div>
                                <div className="recommended_video_wrapper ">
                                    <div className="tabs_wrapper">
                                        <div className="subcription_inner_tabs">
                                            <div className="subscription_main_content">
                                                <div className="row">
                                            {
                                                 query1.data?.listPackagesForApp.map((data) => (
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="plans_wrapper">
                                                        <div className="plans_header d-flex align-items-center">
                                                            <div className="plans_name">
                                                                     <h6>{ data.title}</h6>
                                                                     <p>{ data.subtitle}</p>
                                                            </div>
                                                            <div className="plan_price">
                                                                <h6><span>Starts From</span> {data.validity[0].discountPrice ? data.validity[0].discountPrice : data.validity[0].mrp}</h6>
                                                                {
                                                                    data.validity[0].mrp &&
                                                                    <p><del>₹ {data.validity[0].mrp}</del></p>
                                                                    // <p>20% off <del>₹ {data.validity[0].mrp}</del></p>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="plans_body">
                                                            <ul type="none">
                                                            {
                                                                 data.newDescription && data.newDescription.map((i) => (
                                                                    <li>{i}</li>
                                                                    ))
                                                            }
                                                            </ul>
                                                        </div>
                                                        <div className="plans_footer text-right">
                                                            <h6>
                                                                <a href="javascript:;">
                                                                <Link to={`/package/plan/${data?._id}`} state={JSON.stringify(data)}>
                                                                    Buy Now <img src={Icons.ArrowBlue} alt="" className="img-fluid" />
                                                                </Link>
                                                                </a> 
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>     

                                                    ))
                                                    }
                                                 
                                                    
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        subscription?.packages.length === 0 && <NoDataFound/>
                                    }
                                </div>
                            </div>

                            <div className="col-lg-4 col-md-4 col-sm-12">
                                {/* <div className="videos_wrapper">
                                <div className="buy_packages d-flex align-items-center">
                                    <div className="package_text">
                                        <h6>Buy Package</h6>
                                        <p>Buy Package to unlock content and Start Learning</p>
                                    </div>
                                    <div className="package_img">
                                        <img src={Images.Package} alt="" className="img-fluid"/>
                                    </div>
                                </div>
                            </div> */}
                            </div>
                        </div>
                    </section>
                </div>
    )
}